import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DiscountCode } from '@tokeet-frontend/discount-codes'

export enum DiscountCodeDialogTab {
  DiscountCode,
  Activities,
  Logs,
}

@Component({
  selector: 'app-discount-code-dialog',
  templateUrl: './discount-code-dialog.component.html',
  host: { class: 'template-overlay' },
  styleUrls: ['./discount-code-dialog.component.scss'],
})
export class DiscountCodeDialogComponent implements OnInit {
  activeTab = DiscountCodeDialogTab.DiscountCode
  tabs = DiscountCodeDialogTab
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item?: Partial<DiscountCode> },
    public dialogRef: MatDialogRef<DiscountCodeDialogComponent>
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }

  onSaved() {
    if (!this.data.item || !this.data.item.id) {
      this.close()
    }
  }
}
